module.exports = __webpack_public_path__ + "static/media/Kick808_2.9766e751.wav";